import {yupResolver} from "@hookform/resolvers/yup";
import React from "react";
import {FieldErrors, FormProvider, useForm} from "react-hook-form";
import * as Yup from "yup";

import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {CheckEscalationForm, CheckEscalationFormValues} from "@/pages/checks/update/sections/CheckEscalationForm.tsx";

export interface BulkSetEscalationsFormProps {
  formId: string;
  onSubmit: (data: CheckEscalationFormValues) => void;
  onError?: (errors: FieldErrors<CheckEscalationFormValues>, event?: React.BaseSyntheticEvent) => void;
  serverErrors?: ServerErrors;
}

export const BulkSetEscalationsForm = ({formId, onSubmit, onError, serverErrors}: BulkSetEscalationsFormProps) => {
  const validationSchema = Yup.object({
    escalations: Yup.array()
      .of(
        Yup.object({
          wait_time: Yup.number()
            .required("Wait time is required")
            .test(
              "wait_time-required-if-contact-groups",
              "Wait time is required if Contacts are set.",
              function (value) {
                const {contact_groups} = this.parent;
                const hasContactGroups = Array.isArray(contact_groups) && contact_groups.length > 0;
                const hasWaitTime = value !== undefined && value !== null && value !== 0;
                if (hasContactGroups && !hasWaitTime) {
                  return this.createError({message: "Wait time is required if contact groups are set."});
                }
                return true;
              }
            ),
          contact_groups: Yup.array()
            .of(Yup.number().required())
            .required("Contact groups required")
            .test(
              "contact-groups-required-if-wait-time",
              "Contacts are required if wait time is set.",
              function (value) {
                const {wait_time} = this.parent;
                const hasWaitTime = wait_time !== undefined && wait_time !== null && wait_time !== 0;
                const hasContactGroups = Array.isArray(value) && value.length > 0;
                if (hasWaitTime && !hasContactGroups) {
                  return this.createError({message: "Contact groups are required if wait time is set."});
                }
                return true;
              }
            ),
          num_repeats: Yup.number().required("Repeat times required"),
        })
      )
      .required("At least one escalation is required"),
  });
  const methods = useForm<CheckEscalationFormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      escalations: [],
    },
  });
  return (
    <FormProvider {...methods}>
      <form
        id={formId}
        onSubmit={(e) => {
          methods.handleSubmit(onSubmit, onError)(e);
        }}
      >
        {serverErrors?.schedule_entries && <FormErrorAlerts errors={serverErrors?.schedule_entries} />}
        {serverErrors?.escalations && <FormErrorAlerts errors={serverErrors?.escalations} />}
        <CheckEscalationForm addDefaultRowOnEmpty={true} />
      </form>
    </FormProvider>
  );
};
